import React from "react";
import {
  ActionsMenuItem,
  ActionsMenuItemLabel,
} from "@securspace/securspace-ui-kit";

interface ActionItemProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  show?: boolean;
  enable?: boolean;
}

/**
 * Reusable action menu item component that wraps an icon and label
 * in the standard ActionsMenuItem pattern.
 */
const ActionItem = ({
  label,
  icon,
  onClick,
  show = true,
  enable = true
}: ActionItemProps) => {
  return (
    // @ts-expect-error disabled is a valid prop. Need to edit uikit to indicate this.
    show && <ActionsMenuItem onClick={onClick} disabled={!enable}>
      {icon}
      <ActionsMenuItemLabel>{label}</ActionsMenuItemLabel>
    </ActionsMenuItem>
  );
};

export { ActionItem };